<div class="container wrap-1600" [ngClass]="{ 'wrap-1600': isCustomer }" *ngIf="isAuthorized">
  <ng-container *ngIf="isCustomer">
    <app-customer-header></app-customer-header>
    <app-main-menu></app-main-menu>
  </ng-container>
  <app-header *ngIf="!isCustomer"></app-header>
  <rts-notification slot-id="44_page_1_top"></rts-notification>
  <app-notification-banner style="padding-top: 10px"></app-notification-banner>
  <div class="row" *ngIf="pageHeader">
    <div class="col-12">
      <div class="page-title">{{ pageHeader }}</div>
    </div>
  </div>
  <app-spinner></app-spinner>
  <router-outlet></router-outlet>
  <rts-notification slot-id="44_page_1_footer"></rts-notification>
  <app-custom-toast></app-custom-toast>
</div>
<app-footer></app-footer>
